exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1cJql{-ms-flex-positive:1;flex-grow:1;text-align:left}._3Mnuh{display:inline-block;text-decoration:none}._3Mnuh,._3Mnuh:active,._3Mnuh:visited{color:var(--grey4)}._3Mnuh:hover{text-decoration:underline}.p7dj4{padding:0 4px}@media (min-width:600px){._1cJql{text-align:right}}", ""]);

// exports
exports.locals = {
	"root": "_1cJql",
	"link": "_3Mnuh",
	"spacer": "p7dj4"
};